import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import PromoTeaser from 'components/common/PromoTeaser'
import Theme from 'components/common/Theme/Theme'
import BreadPaymentsBanner from 'components/common/BreadPayments/BreadPaymentsBanner'

const TirePromotion = ({ promotions = [], content = '', showCitiBanner, totalPrice }) =>
  (promotions || (showCitiBanner && content)) &&
    <Wrapper>
      {
        promotions && promotions.length > 0 && <PromoContainer>
          {
            promotions.map(({ promotionTitle, promotionId, promotionType, promotionRebate }, index) =>
              <PromoTeaser
                creative="tire-detail-promo-offers"
                index={ index }
                item={ promotions[index] }
                key={ index }
                promotionId={ promotionId }
                promotionRebate={ promotionRebate }
                promotionType={ promotionType }>
                {promotionTitle}
              </PromoTeaser>
            )
          }
        </PromoContainer>
      }
      {
        showCitiBanner && content && <BreadPaymentsBanner content={ content } totalPrice={ totalPrice } />
      }
    </Wrapper>

export default TirePromotion

TirePromotion.propTypes = {
  content: PropTypes.string,
  promotions: PropTypes.arrayOf(PropTypes.object),
  showCitiBanner: PropTypes.bool,
  totalPrice: PropTypes.string
}

const Wrapper = styled.div`
  border-top: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('padding', '22px 0 60px', '22px 18px 60px')}
`

const PromoContainer = styled.div`
  margin-bottom: 20px;
`
